import { defineComponent as l, openBlock as r, createBlock as a, unref as p, mergeProps as c, withCtx as d, createElementVNode as o } from "vue";
import { RevIcon as f } from "@ds/components/Icon";
const s = /* @__PURE__ */ l({
  name: "IconSoundOff",
  __name: "IconSoundOff",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const t = n;
    return (u, e) => (r(), a(p(f), c(t, { "view-box": "0 0 24 24" }), {
      default: d(() => [...e[0] || (e[0] = [
        o("path", {
          "fill-rule": "evenodd",
          d: "M2.28 2.22a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06L14 13.94V4.811c0-1.058-1.231-1.637-2.046-.964L8.744 6.5H7.25a3.3 3.3 0 0 0-.629.06l-4.34-4.34M8.06 8l4.44 4.44V5.341L9.63 7.714A1.25 1.25 0 0 1 8.832 8H8.061",
          "clip-rule": "evenodd"
        }, null, -1),
        o("path", { d: "m12.5 16.66 1.5 1.5v.528c0 1.058-1.231 1.638-2.046.964L8.744 17H7.25A3.25 3.25 0 0 1 4 13.75v-4a3.2 3.2 0 0 1 .276-1.313l1.226 1.226L5.5 9.75v4a1.75 1.75 0 0 0 1.75 1.75h1.583a1.25 1.25 0 0 1 .796.286l2.871 2.372V16.66" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
